import gql from 'graphql-tag';

export default gql`
  mutation InsertAccount($account: Account_New!) {
    insertAccount(account: $account) {
      id
      name
    }
  }
`;
